import React from 'react'

const HomeSearch = ({  setFilteredArray, array }) => {



    const searchHandler = (text) => {

        if (text) {
            let array1 = [...array]
            setFilteredArray(array1.filter(item => {
                const itemData = `${item.name.toUpperCase()}       
            `;

                const textData = text.toUpperCase();

                return itemData.indexOf(textData) > -1;
            }
            ))

        } else {
            setFilteredArray(array)

        }
    }
    return (
        <div style={{width:'60%'}} >
            <input placeholder='Search here...' className='search_input' onChange={(e) => searchHandler(e.target.value)} />
        </div>
    )
}

export default HomeSearch